import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { initializeApp } from "firebase/app";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { getFirestore, collection, getDocs, doc, getDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyC53ocHQageV9OIfpWv8ATaj3bs8yIajd4",
  authDomain: "recebeepagar.firebaseapp.com",
  projectId: "recebeepagar",
  storageBucket: "recebeepagar.firebasestorage.app",
  messagingSenderId: "1035184709299",
  appId: "1:1035184709299:web:245101941f9484f28c5ac6",
  measurementId: "G-196Y0M3TW7"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const db = getFirestore(app);

const LoginPage = ({ darkTheme }) => {
    const history = useHistory();

    useEffect(() => {
        const fetchAllowedEmails = async () => {
            const querySnapshot = await getDocs(collection(db, "allowedEmails"));
            querySnapshot.forEach((doc) => {
                console.log(`${doc.id} => ${JSON.stringify(doc.data())}`);
            });
        };

        fetchAllowedEmails();
    }, []);

    const handleLogin = async () => {
        try {
            const result = await signInWithPopup(auth, provider);
            const user = result.user;
            const userDoc = await getDoc(doc(db, "allowedEmails", user.email));

            if (userDoc.exists()) {
                console.log('User signed in: ', user);
                history.push('/balance');
            } else {
                console.error('Unauthorized email: ', user.email);
                alert('This email is not authorized to log in.');
                auth.signOut();
                history.push('/login');
            }
        } catch (error) {
            console.error('Error during sign in: ', error);
        }
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', backgroundColor: darkTheme ? '#222' : '#fff', color: darkTheme ? '#fff' : '#000' }}>
            <h1>Login</h1>
            <button onClick={handleLogin} style={{ padding: '10px 20px', fontSize: '16px', cursor: 'pointer', backgroundColor: '#4caf50', color: '#fff', border: 'none', borderRadius: '4px' }}>
                Sign in with Google
            </button>
        </div>
    );
};

export default LoginPage;